
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { HeaderIconsBarDesktop } from '@mg/micro/vue2/HeaderIconsBarDesktop'
import type { HeaderIconTab } from '@mg/micro/vue2/HeaderIconsBarDesktop'
import { FeaturesConfig } from '@mg/web-components/types'
import HeaderCart from '~/components/header/HeaderCart.vue'
import HeaderWishList from '~/components/header/HeaderWishList.vue'
import { GQL_LOCAL_GET_CART } from '~/graphql/gqlLocal/localCart'
import HeaderUser from '~/components/header/HeaderUser.vue'
import {
  GQLLocalAccount,
  GQLLocalOpenHeaderEnum,
  GQLLocalUi,
  GQLLocalUiInput,
} from '~/graphql/__generated__/interfacesLocal'
import {
  GQL_LOCAL_MUTATION_SET_UI,
  GQL_LOCAL_UI,
} from '~/graphql/gqlLocal/localUi'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'

const TAB_NAME_BY_ENUM: Record<GQLLocalOpenHeaderEnum, HeaderIconTab> = {
  [GQLLocalOpenHeaderEnum.User]: 'user',
  [GQLLocalOpenHeaderEnum.WishList]: 'wishlist',
  [GQLLocalOpenHeaderEnum.Cart]: 'cart',
}

@Component({
  apollo: {
    account: GQL_LOCAL_ACCOUNT,
    cart: {
      prefetch: false,
      query: GQL_LOCAL_GET_CART,
    },
    openHeaderTab: {
      prefetch: false,
      query: GQL_LOCAL_UI,
      update(data: { ui: GQLLocalUi }) {
        return data.ui.openHeaderTab
      },
    },
  },
  components: {
    HeaderCart,
    HeaderIconsBarDesktop,
    HeaderUser,
    HeaderWishList,
  },
})
export default class HeaderDesktopIcons extends Vue {
  typeHeaderTab = GQLLocalOpenHeaderEnum
  openHeaderTab: GQLLocalOpenHeaderEnum | null = null
  @Prop({ required: true, type: Boolean }) isHeaderVisible: boolean
  fixedDesktopItemsLoaded: boolean = false
  account: GQLLocalAccount
  openTimeout: NodeJS.Timeout

  @Prop({ required: false, type: Object })
  readonly featuresConfig?: FeaturesConfig

  @Prop({ default: 'right', type: String }) userDropDownPosition:
    | 'left'
    | 'right'

  @Prop({ default: false, type: Boolean }) disableUserLink!: boolean

  get openTabName(): HeaderIconTab | null {
    return this.openHeaderTab ? TAB_NAME_BY_ENUM[this.openHeaderTab] : null
  }

  get visibleIcons(): HeaderIconTab[] {
    const icons: HeaderIconTab[] = ['user']

    if (this.showWishlist) {
      icons.push('wishlist')
    }

    if (this.showCart) {
      icons.push('cart')
    }

    return icons
  }

  get showWishlist(): boolean {
    return this.isLoggedIn && !this.featuresConfig?.disableHeaderWishlist
  }

  get showCart(): boolean {
    return !this.featuresConfig?.disableHeaderCart
  }

  get desktopIsFixed() {
    return this.fixedDesktopItemsLoaded || !this.isHeaderVisible
  }

  @Watch('isHeaderVisible')
  onIsHeaderVisibleChange(val: boolean = false, oldVal: boolean = false) {
    if (val === oldVal) {
      return
    }

    return val
      ? setTimeout(() => (this.fixedDesktopItemsLoaded = false), 100)
      : setTimeout(() => (this.fixedDesktopItemsLoaded = true), 100)
  }

  setUi(ui: GQLLocalUiInput) {
    this.$apollo.mutate({
      mutation: GQL_LOCAL_MUTATION_SET_UI,
      variables: {
        ui,
      },
    })
  }

  changeTab(type: GQLLocalOpenHeaderEnum | null) {
    if (type === null) {
      this.openTimeout = setTimeout(() => {
        this.setUi({
          openHeaderTab: null,
        })
      }, 3000)

      return
    }

    this.openTimeout && clearTimeout(this.openTimeout)

    this.setUi({
      openHeaderTab: type,
    })
  }

  closeTab() {
    this.setUi({
      openHeaderTab: null,
    })
  }

  get isLoggedIn() {
    return !!this.$shopConfig.user?.id || !!this.account?.isLogged
  }

  outside() {
    if (this.openHeaderTab) {
      this.setUi({
        openHeaderTab: null,
      })
    }
  }
}
